import { takeEvery, put, call } from "redux-saga/effects"
import {GET_FEEDBACK_DOCUMENTS_LIST, SUBMIT_DOCUMENTS_LIST} from "./actionTypes"
import { getDocumentListSuccess, submitDocumentListSuccess, submitDocumentListFail,getDocumentListFail} from "./actions"
import {submitDoumnetList,submitDocumentsData} from "../../../../helpers/fakebackend_helper"
//restapi end point
import * as constClass from "../../../../common/constant/constantURL"
// submit feedback
function* getDocumentsListHandler({ payload: {code} }) {
    try {
    var url = constClass.REST_API_DOCUMENTS_LIST;
    var responsJSON = yield call(submitDoumnetList, url+code)
    yield put(getDocumentListSuccess(responsJSON))
  }
  catch (error) {
    yield put(getDocumentListFail(error))
  }
}

function* postDocumentsListHandler({ payload: {jsonData} }) {
  try {
  var url = constClass.REST_API_POST_DOCUMENTS;
  var responsJSON = yield call(submitDocumentsData, url, jsonData);
  yield put(submitDocumentListSuccess(responsJSON))
}
catch (error) {
  yield put(submitDocumentListFail(error))
}
}

function* submitDocumentSaga() {
  yield takeEvery(GET_FEEDBACK_DOCUMENTS_LIST, getDocumentsListHandler);
  yield takeEvery(SUBMIT_DOCUMENTS_LIST, postDocumentsListHandler)
}

export default submitDocumentSaga